import axios from 'axios';

export const apiClient = axios.create({
  baseURL: 'https://strapi.prraco.ir/',
  headers: {
    'content-type': 'application/json',
  },
});
